import { FC } from 'react';

import { useFormContext } from 'react-hook-form';
import { Col, FormGroup, Input, Label } from 'reactstrap';

import { SaveForm } from 'types/pages';
import { s } from 'utilities';

const Primary: FC = () => {
  const { register } = useFormContext<SaveForm>();

  const { ref, ...props } = register('primarySelect');

  return (
    <FormGroup row>
      <Label sm={4}>{s(['Site.Primary', 'Site.Select'])}</Label>
      <Col sm={8}>
        <Input
          {...props}
          innerRef={ref}
          readOnly
          rows={4}
          type="textarea"
        />
      </Col>
    </FormGroup>
  );
};

export default Primary;
